// extracted by mini-css-extract-plugin
export default {"keyboard":"VirtualKeyboard_keyboard__W4MOf","row":"VirtualKeyboard_row__lHwm7","key":"VirtualKeyboard_key__ybvDo","backspace":"VirtualKeyboard_backspace__B0ndx"};